import Dropdown from './Dropdown';
import countries from '../../data/countries.json';

const FilterDropdown = ({ filters, setFilters, categories, onClose }) => {
    const ratingOptions = [
        { value: 1, label: '1 Star & Above' },
        { value: 2, label: '2 Stars & Above' },
        { value: 3, label: '3 Stars & Above' },
        { value: 4, label: '4 Stars & Above' },
    ];

    const selectedCategory = categories.find((cat) => cat.name === filters.category);
    const selectedSubcategory = selectedCategory?.subcategories?.find((sub) => sub.name === filters.subcategory);

    return (
        <div className="filterDropdownDiv">
            <div className="filterHeader">
                <h3>Filters</h3>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={() => setFilters({})}>Clear</button>
                    {/* <button onClick={onClose}>Close</button> */}
                </div>
            </div>
            <div className="filterSection">
                <label>Category</label>
                <Dropdown
                    options={categories.map((cat) => ({ value: cat.name, label: cat.name }))}
                    value={filters.category ? { value: filters.category, label: filters.category } : null}
                    onChange={(selected) => setFilters({ ...filters, category: selected?.value || '', subcategory: '', childcategory: '' })}
                    placeholder="Select Category"
                    isClearable
                />
            </div>
            <div className="filterSection">
                <label>Subcategory</label>
                <Dropdown
                    options={
                        selectedCategory
                            ?.subcategories?.map((sub) => ({ value: sub.name, label: sub.name })) || []
                    }
                    value={filters.subcategory ? { value: filters.subcategory, label: filters.subcategory } : null}
                    onChange={(selected) => setFilters({ ...filters, subcategory: selected?.value || '', childcategory: '' })}
                    placeholder="Select Subcategory"
                    isClearable
                    disabled={!filters.category}
                />
            </div>
            {selectedSubcategory?.children?.length > 0 && (
                <div className="filterSection">
                    <label>Child Category</label>
                    <Dropdown
                        options={selectedSubcategory.children.map((child) => ({ value: child.name, label: child.name }))}
                        value={filters.childcategory ? { value: filters.childcategory, label: filters.childcategory } : null}
                        onChange={(selected) => setFilters({ ...filters, childcategory: selected?.value || '' })}
                        placeholder="Select Child Category"
                        isClearable
                    />
                </div>
            )}
            <div className="filterSection">
                <label>Minimum Rating</label>
                <Dropdown
                    options={ratingOptions}
                    value={
                        filters.minRating
                            ? { value: filters.minRating, label: `${filters.minRating} Stars & Above` }
                            : null
                    }
                    onChange={(selected) => setFilters({ ...filters, minRating: selected?.value || '' })}
                    placeholder="Select Rating"
                    isClearable
                />
            </div>
            <div className="filterSection">
                <label>Seller Country</label>
                <Dropdown
                    options={countries.map((country) => ({ value: country.name, label: country.name }))}
                    value={filters.sellerCountry ? { value: filters.sellerCountry, label: filters.sellerCountry } : null}
                    onChange={(selected) => setFilters({ ...filters, sellerCountry: selected?.value || '' })}
                    placeholder="Select Country"
                    isClearable
                />
            </div>
        </div>
    );
};

export default FilterDropdown;